import SavingsRoundedIcon from '@mui/icons-material/SavingsRounded';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import { always, compose } from 'ramda';
import { ReEnrollmentChecklistPlan } from 're-enrollment-checklist/re-enrollment-checklist.types';
import { ChecklistCard } from 're-enrollment-checklist/ChecklistCard';
import setLegacyChecklistCompletionProgress from 'shared/utils/set-legacy-checklist-completion-progress';

function HsaPlanCard ({ plan }: { plan: ReEnrollmentChecklistPlan; }) {
  const icon = <SavingsRoundedIcon style={ { fontSize: 32 } } />;
  const history = useHistory();
  const buttons = (
    <div className="justify-start" data-testid="hsa-plan-buttons">
      <Button
        variant="outlined"
        className="mr-5"
        data-testid="hsa-link"
        onClick={compose(
          history.push,
          always(`/reenrollment-checklist/hsa/${plan.planYearId}`),
        )}
      >Health Savings account
      </Button>
    </div>
  );

  return (
    <ChecklistCard
      icon={icon}
      title="Health Savings Account"
      planYearStart={plan.planYearStart}
      planYearEnd={plan.planYearEnd}
      buttons={buttons}
      progress={setLegacyChecklistCompletionProgress(plan.legacyChecklistComplete)}
    />
  );
}

export default HsaPlanCard;

